import React, { useState, useEffect } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Row, Col, Alert } from "reactstrap";
import Loading from "../components/Loading";
import { fetchBrand, updateBrand } from "../utils/apiService";

const EditBrandComponent = () => {
  const history = useHistory();
  const { brandId } = useParams();
  const { getAccessTokenSilently } = useAuth0();

  const [form, setForm] = useState({
    orgName: "",
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadBrand = async () => {
      try {
        const token = await getAccessTokenSilently().catch(() => null);
        const data = await fetchBrand(brandId, token);
        // GET /brands/{id} returns { Id: number, name: string }
        setForm({ orgName: data.name || "" });
      } catch (err) {
        setError(err?.message || "Failed to load brand");
      } finally {
        setLoading(false);
      }
    };
    loadBrand();
  }, [brandId, getAccessTokenSilently]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently().catch(() => null);
      const payload = { name: form.orgName };
      await updateBrand(brandId, payload, token);
      history.push("/brands");
    } catch (err) {
      setError(err?.message || "Failed to update brand");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Card>
        <CardHeader>
          <h1 className="mb-0">Edit Brand</h1>
        </CardHeader>
        <CardBody>
          {error && (
            <Alert color="danger">{error}</Alert>
          )}
          <Form onSubmit={onSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="orgName">Brand Name</Label>
                  <Input id="orgName" name="orgName" value={form.orgName} onChange={onChange} required />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex">
              <Button color="secondary" className="me-2" type="button" onClick={() => history.push('/brands')} disabled={submitting}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={submitting}>
                {submitting ? 'Updating...' : 'Update Brand'}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default withAuthenticationRequired(EditBrandComponent, {
  onRedirecting: () => <Loading />,
});
